/**
 * This file was auto-generated by Fern from our API Definition.
 */

export type BlobStorageExportMode =
  | "FULL_HISTORY"
  | "FROM_TODAY"
  | "FROM_CUSTOM_DATE";
export const BlobStorageExportMode = {
  FullHistory: "FULL_HISTORY",
  FromToday: "FROM_TODAY",
  FromCustomDate: "FROM_CUSTOM_DATE",
} as const;
